import { useEffect, useState, useRef } from 'react';
import logger from './../utils/logger.js';


export default function useIsScreenShared() {
  const [isScreenShared, setIsScreenShared] = useState(false);
  const screenStreamRef = useRef(null);

  useEffect(() => {
    const startDetection = async () => {
      try {
        const stream = await navigator.mediaDevices.getDisplayMedia({ video: true });
        screenStreamRef.current = stream;

        const track = stream.getVideoTracks()[0];
        const settings = track.getSettings();

        const isFullScreen = settings.displaySurface === 'monitor'; // full screen
        logger.debug('settings.displaySurface', settings.displaySurface);
        setIsScreenShared(isFullScreen);

        // If user stops sharing
        track.onended = () => {
          setIsScreenShared(false);
          screenStreamRef.current = null;

          // Optional: Restart detection after share ends
          // startDetection();
        };
      } catch (err) {
        logger.warn('User denied or failed screen share:', err);
        setIsScreenShared(false);
      }
    };

    startDetection(); // auto start on mount

    return () => {
      // cleanup on unmount
      if (screenStreamRef.current) {
        screenStreamRef.current.getTracks().forEach((track) => track.stop());
      }
    };
  }, []);

  return { isScreenShared };
}
